import { useEffect, useState } from "react"

export default function Studio(props: any) {
  const [mode, setMode] = useState("Detail");
  const [selectedTemplate, setSelectedTemplate] = useState<string>("");
  const [templateDict, setTemplateDict] = useState<any>({});
  const [progress, setProgress] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  
  useEffect(() => {
    props.onEvent({message: "GetTemplateList", params: {}});
  }, [])

  useEffect(() => {
    if (props.templateList) {
      setTemplateDict(
        Object.fromEntries(props.templateList
          .map((template: any) => ([template.name, template]))
        ))
    }
  }, [props.templateList]);

  let template = templateDict?.[selectedTemplate] || {};
  
  return (
    <div>
      <div style={{display: "flex", justifyContent: "space-between", borderBottom: "solid black 1px"}}>
        <div style={{display: "flex", alignItems: "center"}}>
          <select
            value={selectedTemplate}
            onChange={(e: any) => {
              setSelectedTemplate(e.target.value);
            }}>
            {[""].concat(props.templateList
            .map((templateItem: any, index: number) => templateItem.name))
            .map((templateName: string, index: number) => (
              <option
                key={index}
                value={templateName}>
                {templateName ? templateName : "Please select template"}
              </option>
              ))}
          </select>
          <MenuItem name="Detail" mode={mode} setMode={setMode} />
          <MenuItem name="JSON" mode={mode} setMode={setMode} />
          <MenuItem name="Pipeline" mode={mode} setMode={setMode} />
        </div>
        <div style={{display: "flex"}}>
          <div>{progress}</div>
          {selectedTemplate &&
          <input 
            type="file"
            onClick={(e: any) => {
              e.target.value = null;
            }}
            onChange={async (e: any) => {
              let file = e.target?.files?.[0];
              if (!file) return console.log("No file");
              const arrayBuffer = await new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = () => {
                  resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsArrayBuffer(file);
              });
              if (arrayBuffer) {
                props.onEvent({message: "GenInformatics", 
                  params: {
                    arrayBuffer, setProgress, setImageUrl,
                    template: templateDict?.[selectedTemplate]
                  }});
                setMode("Pipeline");
              }
            }}
          />}
        </div>
      </div>
      {!selectedTemplate ?
      <></> 
      
      : mode === "Pipeline" && imageUrl ?
      <img src={imageUrl} />

      : mode === "Detail" ?
      <div>
        <div>{template.id}</div>
        <div style={{display: "flex", backgroundColor: "lightblue"}}>
          <div style={{flex: 1, border: "solid grey 1px"}}>{template.name}</div>
          <div style={{flex: 1, border: "solid grey 1px"}}>dim</div>
          <div style={{flex: 1, border: "solid grey 1px"}}>dim_type</div>
          <div style={{flex: 1, border: "solid grey 1px"}}>agg</div>
        </div>
        <div>
          {((template.spec || []) as any[])
          .map((field: any) => ({...field, dim: field.dim || false}))
          .toSorted((a: any, b: any) => { 
            return (a.dim > b.dim) ? -1 : 1
          })
          .map((field: any, fieldIndex: number) => (
            <div key={fieldIndex} style={{display: "flex"}}>
              <div style={{flex: 1, border: "solid grey 1px"}}>{field.name}</div>
              <div style={{flex: 1, border: "solid grey 1px"}}>{field.dim?.toString()}</div>
              <div style={{flex: 1, border: "solid grey 1px"}}>{field.dim_type?.toString()}</div>
              <div style={{flex: 1, border: "solid grey 1px"}}>{field.agg?.join(",")}</div>
            </div>
          ))}
        </div>
      </div>
      
      : mode === "JSON" ?
      <div>  
        <textarea
          readOnly={true}
          style={{width: "100%", height: "100%"}}
          rows={50}
          value={JSON.stringify(templateDict?.[selectedTemplate] || {}, null, 1)}
        />
      </div>
      
      :
      <></>}
    </div>
  )
}

function MenuItem(props: any) {
  return(
    <div
      style={{
        padding: "0 5px 0 5px", cursor: "pointer",
        backgroundColor: props.name === props.mode ? "lightblue" : "white"
      }}
      onClick={(e: any) => {
        props.setMode(props.name);
      }}>
      {props.name}
    </div>
  )
}

/* <button
  onClick={(e: any) => {
    props.onEvent({message: "AddTemplate", params: {template}})
  }}>
  Add Template
</button> */